import { Component } from "@angular/core";
import { ControlValueAccessor } from "@angular/forms";
import { Subject } from "rxjs";

@Component({
  template: "",
  standalone: true
})
export class NgModelBaseComponent implements ControlValueAccessor {

    private _innerValue: any;
    private _firsTime: boolean;
    private _firsValue: Subject<any>;

    public get value(): any {
        return this._innerValue;
    }

    public set value(value: any) {

        this._innerValue = value;
        this.onChange(value!);
    }

    public get firsValue(): Subject<any> {
        return this._firsValue;
    }
    public set firsValue(value: Subject<any>) {
        this._firsValue = value;
    }

    constructor() {
        this._innerValue = null;
        this._firsTime = false;
        this._firsValue = new Subject<any>();
    }

    // private onChange!: (_: any) => {};
    private onChange: (value: any) => void = () => {};
    writeValue(value: any): void {
        this._innerValue = value;
        if (this._firsTime) {
        this._firsValue.next(this.value);
        this._firsTime = false;
        }
    }

    // writeValue(value: any): void {

    //   this._innerValue = value
    //   // comentado por un error al asignar valor desde el formcontrolname
    //   if (value !== this._innerValue) {
    //     this.value = value;
    //     if (this._firsTime) {
    //       this._firsValue.next(this.value);
    //       this._firsTime = false;
    //     }
    //   }
    // }
    registerOnChange(fn: (value: any) => void): void {
        this.onChange = fn;
    }

    // registerOnChange(fn: any): void {
    //   this.onChange = fn;
    // }

    registerOnTouched(fn: any): void { }

}
